<div>
  <div class="col-md-12 col-lg-12" style="min-height:50px;">
    <div>
      <div class="col-sm-3 col-md-12"><h4><b>{{ 'pages.createReceiptPage.enterAWB' | translate }}</b></h4></div>
    </div>
    <div class="container">
      <div class="row">
        <div class="col-md-12 col-sm-12">
          <div class="form-group">
            <textarea rows="4" cols="25" style="resize:none" [placeholder]="'pages.createReceiptPage.enterMultipleAwb' | translate" [(ngModel)]="shipmentNumber"></textarea>
          </div>
        </div>
      </div>
      <div class="row">
        <div class="col-md-4 col-sm-4">
          <button class="btn btn-primary" (click)="serachAwbNumber()">{{ 'common.search' | translate }}</button>
        </div>
      </div>

    </div>
    <div class="container">
      <div class="details-container over-flow" *ngIf="isOpen && shipments.length>0">
        <div class="row">
          <table class="table">
            <thead>
              <tr>
                <th>{{ 'pages.createReceiptPage.inboundAwb.inboundAwb' | translate }}</th>
                <th>{{ 'pages.createReceiptPage.inboundAwb.shipmentBussiness' | translate }}</th>
                <th>{{ 'pages.createReceiptPage.inboundAwb.shipperName' | translate }}</th>
                <th>{{ 'pages.createReceiptPage.consigneeName' | translate }}</th>
                <th>{{ 'pages.createReceiptPage.inboundAwb.attentionOff' | translate }}</th>
                <th>{{ 'pages.createReceiptPage.inboundAwb.consigneeTelephone' | translate }}</th>
                <th>{{ 'pages.createReceiptPage.inboundAwb.chargingWeight' | translate }}</th>
                <th>{{ 'pages.createReceiptPage.inboundAwb.totalCharges' | translate }}</th>
                <!--<th>PIN</th> this is for smart shipments which is dissabled now -->
                <th>{{ 'common.otp' | translate }}</th>
                <th>{{ 'common.action' | translate }}</th>
              </tr>
            </thead>
            <tbody>
              <tr *ngFor="let shipment of shipments">
                <td>{{shipment?.Number}}</td>
                <td>{{shipment.Shipment?.BusinessType}}</td>
                <td>{{shipment.Shipment?.ShipperName}}</td>
                <td>{{shipment.Shipment?.ConsigneeName}}</td>
                <td>{{shipment.Shipment?.ConsigneeAttentionOf}}</td>
                <td>{{shipment.Shipment?.ConsigneeTelephone}}</td>
                <td>{{fixDecimals(shipment.Shipment?.ChargeableWeight.Value)}}</td>
                <td>
                  {{
                    calculateTotalCharges(shipment.Shipment?.Customs.Value,shipment.Shipment?.CashOnDelivery.Value,shipment.Shipment?.RatedPrice.Value)
                    + ' ' +
                    getCurrency(shipment)
                  }}
                </td>
               <!-- <td class="action"><span class="armx-icon armx-ok" *ngIf="shipment.Shipment.validated == true"></span><span *ngIf="shipment.Shipment.validated == false" data-toggle="modal" data-target="#PinModal" (click)="setPinNumber(shipment?.Number,shipment.Shipment?.OriginAddress.Entity,shipment.Shipment?.ProductGroup,'')" style="font-size:12px">Validate</span></td>--> <!--this is for smart shipments-->
               <td class="action"><span class="armx-icon armx-ok" *ngIf="shipment.Shipment.OTPValidated == true"></span><span *ngIf="shipment.Shipment.OTPValidated == false" data-toggle="modal" data-target="#PinModal" (click)="setOTPNumber(shipment?.Number,shipment.Shipment?.OriginAddress.Entity,shipment.Shipment?.ProductGroup)" style="font-size:12px">{{ 'common.validate' | translate}}</span></td> 
               <td class="action" (click)="removeShipment(shipment)"><span class="armx-trash-empty"></span></td>
              </tr>
            </tbody>
          </table>
        </div>
      </div>
    </div>
    <div class="row" *ngIf="isOpen && shipments.length>0">
      <div class="col-md-12 col-lg-12">
        <p></p>
      </div>
    </div>
  </div>
</div>

<!--This is for OTP PopUp-->
<!-- Modal -->
<div id="PinModal" class="modal fade" role="dialog">
  <div class="modal-dialog modal-md">
    <!-- Modal content-->
    <div class="modal-content">
      <div class="modal-header">
        <button type="button" class="close" data-dismiss="modal">&times;</button>
        <h3 class="modal-title">{{ 'pages.createReceiptPage.inboundAwb.otpValidation' | translate }}</h3>
      </div>
      <div class="modal-body">
        <div class="container" style="width:100%">
          <div class="row">
            <div class="col-md-12">
              <table class="table">
                <thead>
                  <tr>
                    <th><b>{{ 'pages.createReceiptPage.inboundAwb.waybill' | translate }}</b></th>
                    <th><b>{{ 'pages.createReceiptPage.inboundAwb.origin' | translate }}</b></th>
                    <th><b>{{ 'pages.createReceiptPage.productGroup' | translate }}</b></th>
                  </tr>
                </thead>
                <tbody>
                  <tr>
                    <td>{{OTPObject.waybillNumber}}</td>
                    <td>{{OTPObject.origin}}</td>
                    <td>{{OTPObject.productGroup}}</td>
                  </tr>
                </tbody>
              </table>
            </div>

            <div class="col-md-12 form-inline">

              <div class="form-group col-md-5 col-xs-5 col-sm-5">
                <input type="text" class="form-control" [(ngModel)]="OTPNumber" placeholder="OTP Number" style="width:100%">
                <br />
              </div>
              <div class="form-group col-md-6 col-xs-6 col-sm-6">
                <button type="button" class="btn btn-primary" (click)="validateOTPShipment($event)">{{ 'pages.createReceiptPage.inboundAwb.validateOtp' | translate }}</button>
                <button type="button" class="btn btn-primary" data-dismiss="modal">{{ 'common.cancel' | translate }}</button>
                <br />
                <span *ngIf="ShowMessage" class="red" style="color: #dc291e;">{{MessageContent}}</span>
              </div>
              <div class="col-md-1 col-sm-1 col-xs-1">
                <img *ngIf="hideLoader == false" src="../../assets/img/red-loader.gif" class="loaders-btns" />
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>

<!-- Modal -->
<!--This is for Smart shipments-->
<!-- 
<div id="PinModal" class="modal fade" role="dialog">
  <div class="modal-dialog modal-md">
    
    <div class="modal-content">
      <div class="modal-header">
        <button type="button" class="close" data-dismiss="modal">&times;</button>
        <h3 class="modal-title">Smart Shipments</h3>
      </div>
      <div class="modal-body">
        <div class="container" style="width:100%">
          <div class="row">
            <div class="col-md-12">
              <table class="table">
                <thead>
                  <tr>
                    <th><b>Waybill</b></th>
                    <th><b>Origin</b></th>
                    <th><b>Product Group</b></th>
                    <th><b>Status</b></th>
                  </tr>
                </thead>
                <tbody>
                  <tr>
                    <td>{{pinObject.waybillNumber}}</td>
                    <td>{{pinObject.origin}}</td>
                    <td>{{pinObject.productGroup}}</td>
                    <td>{{pinObject.status}}</td>
                  </tr>
                </tbody>
              </table>
            </div>

            <div class="col-md-12 form-inline">

              <div class="form-group col-md-5 col-xs-5 col-sm-5">
                <input type="text" class="form-control" [(ngModel)]="pinNumber" (change)="showPinNumberIsRequired = false" placeholder="Pin Number" style="width:100%">
                <br />
                <span *ngIf="showPinNumberIsRequired" class="red" style="color: #dc291e;">Required</span>
              </div>
              <div class="form-group col-md-6 col-xs-6 col-sm-6">
                <button type="button" class="btn btn-primary" (click)="validateSmartShipment()">Validate Pin</button>
                <button type="button" class="btn btn-default {{resendPin}}" (click)="resendPinSmartShipment()">Resend Pin</button>
              </div>
              <div class="col-md-1 col-sm-1 col-xs-1">
                <img *ngIf="hideLoader == false" src="../../assets/img/red-loader.gif" class="loaders-btns" />
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</div> -->